export default {
  label: {
    sk: 'Ochrana osobných údajov',
    en: 'Personal data protection',
  },
};



// WEBPACK FOOTER //
// ./src/modules/GDPR/messages.js